enum KioskDeviceType {
  iPad = 1,
  iPadPro = 2,
  AndroidElo15 = 3,
  AndroidElo22 = 4,
  AndroidElo22Backpack = 5,
  AndroidElo32Backpack = 6,
  AndroidEloBackpackWorkspaceOne = 8,
  AndroidElo22WorkspaceOne = 9,
  ChromeOsElo22 = 10,
  ChromeOsElo15 = 11,
  AndroidZebraET40 = 50,
  AndroidLenovoK10 = 100,
  AndroidLenovoM90n = 110,
  AndroidHPEngagePro19_5 = 150,
  AndroidHPEngagePro24 = 160,
  AndroidSamsungGalaxyTabASeries = 170,
  AndroidSamsungGalaxyTabActiveProSeries = 171,
  AndroidSamsungGalaxyTabSSeries = 172,
  AndroidSunmi215 = 200,
  AndroidMicroTouch22 = 250,
  AndroidPosiflexMercury = 275,
  AndroidPyramidFlex215 = 300,
  AndroidTouchDynamic = 305,
  TizenSamsungKM24A = 350,
  ChromeOsSamsungKM24W = 351,
  ChromeOsSamsungKM24ALenovoChromeBox = 352,
  ChromeOsLenovoChromeBox = 361,
  ChromeOsLenovoM90n = 362,
  ChromeOsLG27KC3PK_C = 375,
  ChromeOsHPEngagePro24 = 400,
  ChromeOsHPEngagePro19_5 = 401,
  ChromeOsAcrelecK22 = 415,
  ChromeOsPosiflexMercury = 420,
  ChromeOsTouchDynamicEdgeUltra22 = 430,
  ChromeOsMicroTouch22 = 440,
}

export { KioskDeviceType };
